export default "__VITE_ASSET__bJBBoTTL__"